<template>
    <ScreenAdapter>
    <div id="main">
        <Header />
        <Nav />
        <!-- <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div> -->
        <div class="eol-main-container">
            <div class="article-list">
                <div class="left-list">
                    <div class="body-box">
                        <div class="article-header">
                            <div class="title">{{ newDetails.title }}</div>
                            <!-- 头部 PC端显示 -->
                            <div class="other pc">
                                <div v-if="newDetails && newDetails.source" class="source">文章来源 : {{ newDetails.source }}</div>
                                <div v-if="newDetails && newDetails.source && newDetails.publish_time" class="split">|</div>
                                <div v-if="newDetails && newDetails.publish_time" class="time">时间 : {{ newDetails.publish_time }}</div>
                            </div>
                        </div>
                        <!-- 文章内容 -->
                        <div class="article-body" v-html="newDetails.content"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</ScreenAdapter>
</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../config/services'
import utils from "../../config/utils";
import ScreenAdapter from "@/components/ScreenAdapter.vue"
export default {
    data() {
        let that = this
        const isPro = process.env.NODE_ENV == 'production' && process.env.VUE_APP_FLAG === 'pro'
        const siteId = isPro ? 7 : 3
        return {
            cover: require("../../assets/hzvtc/cover/zyqsz.jpg"),
            school_code: services.HZ_CODE,
            siteId,
            newId: 0,
            newDetails: {},
            fileOrigin: '', // 加载播放器脚本的文件路径
            players: [] // content 中富文本视频对应的播放器实例
        }
    },
    components: {
        Header,
        Nav,
        Footer,
        ScreenAdapter
    },
    async mounted() {
        let that = this
        that.newId = that.$route.query.id
        let fileOrigin = window.location.origin
        if (process.env.NODE_ENV == 'production') {
            this.fileOrigin = fileOrigin + '/center'
        } else {
            this.fileOrigin = fileOrigin
        }
        this.getNewsData()
    },
    beforeDestroy() {
        this.players.forEach(player => player && player.dispose())
        this.players = []
    },
    methods: {
        onPageChange(val) {
            this.page = val
            this.getListData()
        },
        async getNewsData() {
            let params = { id: this.newId, site_id: this.siteId}
            // 专业群思政 - 思政资源
            await services.getRmtNewsDetail(params).then(res => {
                if (res.code == '0000') {
                    this.newDetails = res.data
                    this.$nextTick(() => {
                        this.initVideo()
                    })
                } else {
                    this.newDetails = {}
                }
            })
        },
        initVideo() {
            let that = this
            // 找出富文本内容中的所有 video 标签
            let videoEls = Array.from(
                that.$el.querySelectorAll('.article-body video[data-fileid]')
            )
            if (!videoEls.length) return
            // 加载播放器依赖脚本，加载完成后逐个初始化
            utils.loadScript(this.fileOrigin + "/school/js/hls.min.0.8.8.js", () => {
                utils.loadScript(this.fileOrigin + "/school/js/tcplayer.min.js", () => {
                    if (typeof window.TCPlayer !== "function") return
                    videoEls.forEach(el => {
                        let id = el.getAttribute('id')
                        let fileID = el.getAttribute('data-fileid')
                        let appID = el.getAttribute('data-appid') || '1500004122'
                        if (!id || !fileID) return
                        // video 标签自带宽高则用标签的，否则用默认尺寸
                        let width = el.getAttribute('width') || 1000
                        let height = el.getAttribute('height') || 563
                        let player = window.TCPlayer(id, {
                            // 容器ID必须与 video 标签的 id 一致
                            fileID: fileID, // 视频 fileID 必须
                            appID: appID, // 点播账号 appID 必须
                            controls: true,
                            playbackRates: [0.5, 1, 1.25, 1.5, 2],
                            width: width, // 视频显示宽度
                            height: height, // 视频显示高度
                            definition: 30,
                            autoplay: false
                        })
                        that.players.push(player)
                    })
                })
            })
        }
    },
}
</script>

<style lang="less" scoped>
#main {
    background-color: #FFFFFF;
}

.platform-cover {
    width: 100%;
    height: 510px;
}

.eol-main-container {
    background-color: #FFFFFF;
    width: 1400px;
    margin: 37px auto 45px;
    display: flex;
    text-align: center;
    font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "Arial", "sans-serif";
}

.article-list {
    margin: 0 auto;
    display: block;
    min-height: 100% !important;
}

.article-header .title {
    width: 100%;
    font-size: 36px;
    color: #000000;
    font-weight: bold;
    text-align: center;
    line-height: 1.5;
}

.article-header .other .source,
.article-list .left-list .other .source {
    margin-right: 0;
}

.article-list .left-list .other .split {
    margin: 0 8px;
    font-size: 14px;
    color: #cbcbcb;
}

.article-header .other .source,
.article-list .left-list .other .source {
    align-items: center;
}

.article-list .left-list .other {
    color: #999999;
    justify-content: center;
    padding: 30px 0 33px;
    display: flex;
    align-items: center;
    font-size: 12px;
    position: relative;
}


.video-js {
    overflow: hidden;
    margin: 0 auto;
    width: 772px;
    height: 434px;
}

.video-zone .video-js {
    width: 560px;
    height: 747px;
}

.video-zone .video-js video {
    width: 100% !important;
    height: 100% !important;
}

:deep .body-box .article-body {

    img,
    audio {
        max-width: 100% !important;
        height: auto !important;
    }

    // 富文本中的图片居中显示
    img {
        display: block;
        margin: 0 auto;
    }

    video {
        max-width: 100% !important;
    }

    // 富文本中的视频播放器居中显示
    .video-js {
        display: block;
        margin: 0 auto;
    }

    p {
        line-height: 36px !important;
        font-size: 18px;
    }

    p:not(:last-child) {
        padding-bottom: 22px;
    }
}

@media screen and (min-width: 960px) {
    .eol-body-box {
        min-height: calc(100vh - 285px);
    }

    .other.h5 {
        display: none !important;
    }

    .article-list .left-list {
        width: 1100px;
        margin: 0 auto;
    }

    .right-list {
        width: 335px;
        top: 185px;
        position: absolute;
        right: 30px;
    }

    .eol-container-box .eol-search-box .eol-search-left>img:not(:first-child) {
        width: 210px !important;
    }
}
</style>